export default __webpack_public_path__ + "static/media/member.5f5b629b.png";